import React from 'react';

const PrivacyTable = () => {
    return (
        <div className="overflow-x-auto rounded-lg border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
                <thead>
                <tr className="bg-gray-50">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Purpose
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Type of Data
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Lawful basis for processing and condition for processing special category data (Face Data)
                    </th>
                </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-900">
                        To register you as a new user of the App
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4">
                            <li>Identity</li>
                            <li>Contact</li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Performance of a contract with you</li>
                        </ul>
                    </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-900">
                        Collection of Nivo Data forming part of your Nivo ID
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Contact</li>
                            <li>Financial</li>
                            <li>Identity (including copies of ID reports provided to particular lenders or brokers)</li>
                            <li>Biometric Data which forms part of the Identity Data ("Face Data")</li>
                            <li>Criminal offence data but only to the extent this appears in public documents such as
                                press articles and Nivo collects it as part of undertaking anti money laundering checks
                            </li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Performance of a contract with you (to maintain your Nivo ID as set out in the Nivo End
                                User Licence Agreement)
                            </li>
                            <li>Necessary for Nivo's legitimate interest (to keep its records of your Nivo ID updated
                                and to verify your identity and, in relation to anti money laundering checks, to check
                                publicly available data in relation to sanctions and political exposure)
                            </li>
                            <li>Consent (in relation to your Face Data)</li>
                            <li>The condition for Nivo holding special category data (being your Face Data) under
                                Article 9 UK GDPR is explicit consent under Article 9(2)(a).
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-900">
                        Sharing of Nivo Data with third parties such as lenders and brokers
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Contact</li>
                            <li>Financial</li>
                            <li>Identity (including copies of ID reports provided to particular lenders)</li>
                            <li>Biometric Data which forms part of the Identity Data (Face Data)</li>
                            <li>Criminal offence data but only to the extent this appears in public documents such as
                                press articles and Nivo collects it as part of undertaking anti money laundering checks
                            </li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Consent</li>
                            <li>The condition for Nivo sharing special category data (being your Face Data) under
                                Article 9 UK GDPR is explicit consent under Article 9(2)(a). You will always be asked to
                                specifically consent to a third party receiving your Face Data, and will be provided
                                with a link to their privacy notice setting out how they process Face Data.
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-900">
                        To manage Nivo's relationship with you which will include:
                        <ul className="list-disc ml-4 mt-2 space-y-2 leading-relaxed">
                            <li>Replying to requests for information</li>
                            <li>Notifying you about changes to the end user licence agreement or privacy policy</li>
                            <li>Asking you to leave a review or take a survey</li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Identity</li>
                            <li>Contact</li>
                            <li>Marketing and Communications</li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Performance of a contract with you</li>
                            <li>Necessary to comply with legal obligations</li>
                            <li>Necessary for Nivo's legitimate interests (to keep our records updated and to study how
                                app users use our services)
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-900">
                        To administer and protect Nivo's business and this app (including troubleshooting, data analysis, testing, system maintenance, support, reporting and hosting of data)
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Identity</li>
                            <li>Contact</li>
                            <li>Technical</li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Necessary for Nivo's legitimate interests (for running its business, provision of administration and IT services, network security, to prevent fraud and in the context of a business reorganisation or group restructuring exercise)</li>
                            <li>Necessary to comply with a legal obligation</li>
                        </ul>
                    </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-900">
                        To use data analytics to improve this app, services, marketing, customer relationships and experiences
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Technical</li>
                            <li>Usage</li>
                        </ul>
                    </td>
                    <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">
                        <ul className="list-disc ml-4 space-y-2 leading-relaxed">
                            <li>Necessary for Nivo's legitimate interests (to define types of customers, to keep the app updated and relevant, and to develop its business)</li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PrivacyTable;